// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21":"fbbb1f89","210":"9f5a5874","290":"14c702ff","353":"674c789c","593":"b7f387ad","733":"14c702ff","826":"14c702ff","896":"2ffaf430","976":"14c702ff"}[chunkId] + ".chunk.css";
};